
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SaveChangesBar',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
})
